import { useEffect, useState } from "react"
import _head from "lodash/head"
import _size from "lodash/size"
import _find from "lodash/find"

import { getProducts } from "services/state/actions"

import {
  filterOnlyMobileProductsWithDetail,
  mapNumberAsOption
} from "./handleGetMonthsDetailing"

const initialState = {
  selected: {
    value: "",
    label: ""
  },
  productSelected: null
}

export const useProductsOptions = () => (dispatch, getState) => {
  const { customer, products } = getState()
  const [optionSelected, setOptionSelected] = useState(initialState)
  const { data } = products

  const productsMobile = filterOnlyMobileProductsWithDetail(data)
  const options = mapNumberAsOption(productsMobile)

  const firtSelected = getFirstSelected(options, productsMobile)
  const notFindProductsWithDetail = !_size(productsMobile) && _size(data) > 0

  useEffect(() => {
    if (customer.customerSegment !== "CORPORATE") {
      getProducts({ page: 0, pageSize: "99999" })(dispatch)
    } else {
      getProducts({ page: 0, pageSize: "99999" })(dispatch)
    }
  }, [])

  const onChangeOption = (value) => {
    const selected = _find(options, (item) => item.value === value)
    const productSelected = getProductSelected(selected, productsMobile)

    setOptionSelected({
      selected,
      productSelected
    })
  }

  return [
    optionSelected.productSelected ? optionSelected : firtSelected,
    options,
    notFindProductsWithDetail,
    onChangeOption
  ]
}

const getFirstSelected = (options, data) => {
  const firstOption = _head(options) || initialState.selected

  return {
    selected: firstOption,
    productSelected: getProductSelected(firstOption, data)
  }
}

const getProductSelected = (selected, data) => {
  if (!selected.value || !_size(data)) return null
  return _find(data, (item) => item.productKey === selected.value)
}



// WEBPACK FOOTER //
// ./src/scenes/DetailingPosPreControle/utils/useProducts.js